import type { MessageKey } from 'types/LocaleMessageKey';

import type { ImageFormat } from '@/app/components/Image';

export interface AccoladeSlide {
  text: string;
  year?: string;
  image?: { path: string; format: ImageFormat; alt: string };
  source?: {
    name: string;
    role?: MessageKey;
  };
}
export const accoladesSlides: AccoladeSlide[] = [
  {
    text: 'cnbc_disruptor_list',
    year: '2024 & 2022',
    image: {
      path: 'product-accolades/cnbc-disruptor-logo',
      format: 'png',
      alt: 'CNBC Disruptor 50 Logo',
    },
  },
  {
    text: 'membership_accolades_slide_1_text',
    image: {
      path: 'product-accolades/allure',
      format: 'png',
      alt: 'Allure Logo',
    },
  },
  {
    text: 'membership_accolades_slide_2_text',
    image: {
      path: 'product-accolades/techradar',
      format: 'png',
      alt: 'TechRadar Logo',
    },
  },
  {
    text: 'membership_accolades_slide_3_text',
    image: {
      path: 'product-accolades/gma',
      format: 'png',
      alt: 'Good Morning America Logo',
    },
  },
  {
    text: 'membership_accolades_slide_4_text',
    image: {
      path: 'product-accolades/techradar',
      format: 'png',
      alt: 'TechRadar Logo',
    },
  },
  {
    text: 'membership_accolades_slide_6_text',
    image: {
      path: 'product-accolades/time-color-logo',
      format: 'png',
      alt: 'Time Magazine Logo',
    },
  },
  {
    text: 'membership_accolades_slide_7_text',
    source: {
      name: 'Connie W',
      role: 'oura_member',
    },
  },
  {
    text: 'membership_accolades_slide_8_text',
    source: {
      name: 'Olli H',
      role: 'oura_member',
    },
  },
  {
    text: 'membership_accolades_slide_9_text',
    source: {
      name: 'Shara',
      role: 'oura_member',
    },
  },
];
